import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminFaqModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminFaqModule;